import { Link } from '@inertiajs/react'
import { LanguageFlag } from '@/components/ui/LanguageFlag'
import type { LanguageRow } from '@/content/landing'

interface LanguagesGridProps {
  languages: LanguageRow[]
}

export function LanguagesGrid({ languages }: LanguagesGridProps) {
  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-x-9">
        {languages.map((lang) => (
          <Link
            key={lang.code}
            href={lang.href}
            className="group flex items-center gap-3.5 py-4 border-b border-line-soft hover:border-accent transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 rounded-sm"
          >
            <LanguageFlag isoCode={lang.code} size="m" />
            <span className="flex flex-col min-w-0">
              <span className="font-serif text-[19px] leading-[1.1] text-body group-hover:text-accent transition-colors duration-200">
                {lang.native}
              </span>
              <span className="font-mono text-[11.5px] tracking-[0.02em] text-muted mt-0.5">
                {lang.english}
              </span>
            </span>
          </Link>
        ))}
      </div>
      <p className="font-serif italic text-base text-muted pt-8">
        Don't see yours? It's likely on the way.
      </p>
    </div>
  )
}
